(function (angular) {
    'use strict';

    angular.module("branchReports")
        .controller("ReportsChannelsCtrl", [
            "$scope", '$stateParams', 'channelsService', 'growlService', 'chartsService', 'channelsData', 'sharedDataService', 'chartFactoryService', 'sharedChannelService', function ($scope, $stateParams, channelsService, growlService, chartsService, channelsData, sharedDataService, chartFactoryService, sharedChannelService) {
                var mode = "allChannels";
                var data = {};
                $scope.data = {};

                $scope.channels = sharedChannelService.getChannels(mode);

                function filterChannelData() {
                    sharedChannelService.filterChannelData(mode, channelsData, $scope.channels);
                }

                filterChannelData();

                Chart.elements.Rectangle.prototype.draw = chartFactoryService.roundedCornersBars;

                $scope.getData = function () {
                    chartsService.setData($scope.query.from, $scope.query.to, $scope.query.system);
                    $scope.query.by = chartsService.getSampling();

                    channelsService.getQueriedDataAgregated($stateParams.pickedApiSpaceId, chartsService.data, sharedDataService.timeZone).then(function (result) {

                        data = {};
                        $scope.channels.forEach(function (channel) {
                            data[channel.id] = {};

                            channel.statuses.forEach(function (status) {
                                data[channel.id][status.id] = _.reduce(result, function (sum, el) {
                                    if (el[status.id] && el[status.id][channel.id]) {
                                        return sum + el[status.id][channel.id];
                                    } else {
                                        return sum;
                                    }
                                }, 0);
                            });

                        });
                        $scope.displayVariables();
                        growlService.success('Data correctly downloaded ', 10, true);
                    }).catch(function (error) {
                        growlService.danger("Data didn't downloaded due to: " + error.statusText);
                    });
                };


                var ctx = {};
                var charts = {};
                var chartData = {};


                $scope.displayVariables = function () {

                    $scope.labels = {};

                    $scope.data = {};
                    $scope.channels.forEach(function (channel) {
                        $scope.labels[channel.id] = channel.statuses.map(function (status) {
                            return status.label;
                        });
                        $scope.data[channel.id] = _.flatMap(data[channel.id]);
                    });


                    $scope.channels.forEach(function (channel) {

                        channel.allZeros = !_.some($scope.data[channel.id], function (el) { return el !== 0; });

                        // need to destroy chart when reloading data, if not destroyed it will be drawn one over another

                        if (charts[channel.id]) {
                            charts[channel.id].destroy();
                        }

                        if (!channel.allZeros && channel.configured) {
                            var canvas = document.getElementById(channel.id);
                            ctx[channel.id] = canvas.getContext("2d");
                            var barGradient = ctx[channel.id].createLinearGradient(0, 0, 400, 0);
                            barGradient.addColorStop(0, channel.color[0]);
                            barGradient.addColorStop(1, channel.color[1]);


                            chartData[channel.id] = {
                                labels: $scope.labels[channel.id],
                                datasets: [chartFactoryService.singleChannelDataSetBar(barGradient, $scope.data[channel.id])]
                            };

                            canvas.style.width = "100%";
                            canvas.width = canvas.offsetWidth;


                            var options = chartFactoryService.singleChannelDataOptionsBar;

                            options.scales.yAxes[0].ticks.fontFamily = "'Lato'";
                            options.scales.yAxes[0].ticks.fontSize = 13;
                            options.scales.yAxes[0].ticks.fontWeight = 500;
                            options.layout.padding.top = 0;
                            options.layout.padding.left = 0;
                            options.scales.yAxes[0].categoryPercentage = 1.0;
                            options.scales.yAxes[0].barPercentage = 1.0;


                            charts[channel.id] = new Chart(ctx[channel.id], {
                                type: 'horizontalBar',
                                data: chartData[channel.id],
                                tooltips: false,
                                options: options
                            });

                        }

                    });

                };


                $scope.query = {
                    from: {
                        value: moment().startOf('month').toDate()
                    },
                    to: {
                        value: moment().toDate()
                    },
                    system: 'all'
                };

                $scope.$emit('reports:channels:stateChange', $scope.query);


                $scope.$on('reports:channels:dateRangeChange',
                    function (e, message) {
                        $scope.query = message;
                        $scope.getData();
                    }
                );

                $scope.getData();

            }
        ]);

})(window.angular);

